"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=sign.js.map